import { X } from "lucide-react";
import { Popover, PopoverAnchor, PopoverContent } from "@bookdental/ui";

type Props = {
  open: boolean;
  onDismiss: () => void;
  onStartTour: () => void;
  children: React.ReactNode;
};

/** Balão de ênfase mostrado só uma vez, logo após o usuário completar o onboarding — chama
 *  atenção pro ícone de tour sem abrir o tour sozinho (ver use-product-tour.ts). */
export function TourCallout({ open, onDismiss, onStartTour, children }: Props) {
  return (
    <Popover open={open} onOpenChange={(next) => !next && onDismiss()}>
      <PopoverAnchor asChild>{children}</PopoverAnchor>
      <PopoverContent
        align="end"
        sideOffset={10}
        className="w-64 rounded-xl border border-zinc-200 bg-white p-3.5 shadow-2xl dark:border-border dark:bg-card"
      >
        <div className="flex items-start justify-between gap-2">
          <p className="text-[13px] font-medium leading-snug text-zinc-800 dark:text-foreground">
            Conheça a plataforma — clique aqui pra um tour rápido pelas funções principais.
          </p>
          <button
            type="button"
            onClick={onDismiss}
            aria-label="Fechar dica"
            className="flex h-5 w-5 shrink-0 items-center justify-center rounded-md text-zinc-400 transition-colors hover:bg-zinc-100 hover:text-zinc-700 dark:hover:bg-muted dark:hover:text-foreground"
          >
            <X className="h-3 w-3" />
          </button>
        </div>
        <button
          type="button"
          onClick={onStartTour}
          className="mt-2.5 inline-flex h-7 items-center rounded-md bg-brand-600 px-3 text-[12px] font-semibold text-white transition-colors hover:bg-brand-700"
        >
          Ver agora
        </button>
      </PopoverContent>
    </Popover>
  );
}
